import { UserTable } from "../../../components/user-table";

const UserDirectoryPage = () => {
    return <UserTable maxHeight="100%" />;
};

export default UserDirectoryPage;
